function generateColor(color) {
  return ["#0083FF", color];
}

export default generateColor;